<template>
<main-content v-if="$can('manage', 'gateway')">
    <ul class="nav nav-pills">
        <li class="nav-item">
            <a @click="setTab('gateways')" :class="['nav-link', active_tab == 'gateways' ? 'active' : '']" href="#" v-text="$t('label.gateways')"></a>
        </li>
        <li class="nav-item">
            <a @click="setTab('requests')" :class="['nav-link', active_tab == 'requests' ? 'active' : '']" href="#" v-text="$t('label.requests')"></a>
        </li>
    </ul>
    <div v-if="active_tab == 'gateways'">
        <manage-dedicated></manage-dedicated>
    </div>
    <div v-else-if="active_tab == 'requests'">
        <dedicated-requests></dedicated-requests>
    </div>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import ManageDedicated from './components/manage-dedicated'
import DedicatedRequests from './components/dedicated-requests'

export default {
    components: {
        'main-content': mainContent,
        'manage-dedicated': ManageDedicated,
        DedicatedRequests,
    },
    data() {
        return {
            active_tab: 'gateways',
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
        }
    },
    methods: {
        setTab(value) {
            this.active_tab = value;
        },
    },
}
</script>

<style>

</style>